/**
 * KEY-817: "the calendars were just synced" — said by the account menu's Sync calendars, heard by an open dial so it
 * reads its days again. A window event rather than shared state: the menu lives in the header, the dial in the page,
 * and neither should have to know the other is there.
 */
export const CALENDARS_SYNCED_EVENT = "kd:calendars-synced";

export function announceCalendarsSynced(): void {
  window.dispatchEvent(new Event(CALENDARS_SYNCED_EVENT));
}

/** How long after starting a background sync an open dial looks again. Most syncs finish in a few seconds. */
export const CALENDAR_REFRESH_LOOK_AGAIN_MS = 10_000;

/** What the menu item says after a sync, from what came back. */
export function syncOutcome(connections: ReadonlyArray<{ lastSyncError?: string | null }>): string {
  const failed = connections.filter((c) => !!c.lastSyncError).length;
  if (connections.length === 0) return "No calendars to sync";
  if (failed === 0) return connections.length === 1 ? "Calendar synced" : `${connections.length} calendars synced`;
  if (failed === connections.length) return connections.length === 1 ? "Couldn't sync — see Settings" : "None synced — see Settings";
  return `${connections.length - failed} of ${connections.length} synced — see Settings`;
}
